module.exports = __webpack_public_path__ + "static/media/Vending.42e46283.svg";